import { PreviewTypes } from 'shared/domains/documents/utils/types';
import { PDFDataProvider } from './PDFDataProvider';
const SUPPORT_PREVIEW_TYPES = [PreviewTypes.DOCX, PreviewTypes.PDF]; // We only want to wrap `DOCX` and `PDF` in the `PDFDataProvider`
export function PDFDataProviderWrapper(props) {
    const { children, previewType } = props;
    const supported = SUPPORT_PREVIEW_TYPES.includes(previewType);
    if (supported) {
        return <PDFDataProvider>{children}</PDFDataProvider>;
    }
    return children;
}
